<template>
  <base-page-component :has-nav="false">
    <div class="o-y-auto noscroll bg-white" style="height: calc(100% - 50px)">
      <div class="m-auto" style="min-height: 100%;width: 885px">
        <div class="h-full">
          <div class="flex a-top j-start h-full w-full">
            <div class="flex-s-0 p-v-5" style="width: 245px">
              <div class="m-h-40 m-v-30 b-radius-4" style="height: 270px;background-color: #F8F8F9">
                <div class="w-full flex-column a-center j-center" style="height: 140px;">
                  <div>
                    <img :src="getshowUserIcon" alt=""
                         class="border"
                         style="width: 66px;height: 66px;border-radius: 50%">
                  </div>
                  <div class="color-333 fs-16 bold m-t-5">{{ listDatas.user? listDatas.user.name || '' :'' }}</div>
                </div>
                <div class="flex-column p-h-20 fs-14 color-666" style="height: 130px">
                  <div class="flex-1 flex-s-0 flex a-center j-center w-full">
                    <div class="flex-1 flex-s-0 flex-column a-center j-center">
                      <div>
                        分享
                      </div>
                      <div class="m-t-5" style="color: #007AFF">
                        0
                      </div>
                    </div>
                    <div class="flex-1 flex-s-0">
                      <div class="flex-1 flex-s-0 flex-column a-center j-center">
                        <div>
                          点赞
                        </div>
                        <div class="m-t-5" style="color: #007AFF">
                          {{listDatas.praiseCount || 0}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex-1 flex-s-0 w-full">
                    <div class="flex-1 flex-s-0 flex a-center j-center">
                      <div class="flex-1 flex-s-0 flex-column a-center j-center">
                        <div>
                          收藏
                        </div>
                        <div class="m-t-5" style="color: #007AFF">
                          0
                        </div>
                      </div>
                      <div class="flex-1 flex-s-0">
                        <div class="flex-1 flex-s-0 flex-column a-center j-center">
                          <div>
                            阅读
                          </div>
                          <div class="m-t-5" style="color: #007AFF">
                            {{listDatas.readCount || 0}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full h-full">
              <div class="h-full" style="padding: 30px 0 0 0">
                <div class="flex p-b-10">
                  <div class="m-t-4 w-full">
                    <div class="flex a-center m-b-15" style="height: 34px;background-color:#F8F8F9">
                      <div class="color-333 fs-14 p-l-10">发布时间：{{ listDatas.publishTime }}</div>
                      <div class="flex-1"></div>
                      <div @click="delItem" class="p-h-10 text-red fs-14">
                        删除
                      </div>
                    </div>
                    <div class="p-h-10">
                      <div class="fs-16 color-333 bold" v-html="listDatas.title"/>
                      <div class="fs-14 color-333 " v-html="listDatas.content">
                      </div>
                      <div class="m-t-10" v-if="getShowVideoUrl">
                        <video :src="getShowVideoUrl" class="w-500" controls>
                        </video>
                      </div>

                      <div class="m-t-10" style="width: 572px">
                        <!--<img :key="index" :src="item.imgUrl" alt="" class="m-r-10" style="width: 130px;height: 95px;"-->
                        <!--v-for="(item,index ) in listDatas.imgList">-->
<!--                        <div v-if="listDatas.imgList && listDatas.imgList.length>1">-->
<!--                          <div :key="index" @click="preview(item)" class="flex a-center j-center o-hidden m-r-10"-->
<!--                               style="display: inline-block;width: 148px;height: 105px;"-->
<!--                               v-for="(item,index ) in listDatas.imgList">-->
<!--                            <img :src="item.imgUrl" alt="" class="w-full" style="min-height: 105px">-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div v-if="listDatas.imgList && listDatas.imgList.length===1">-->
<!--                          <img :src="listDatas.imgList[0].imgUrl" @click="preview(listDatas.imgList[0])" alt=""-->
<!--                               class="m-r-10"-->
<!--                               style="width: 300px;min-height: 105px">-->
<!--                        </div>-->
                        <ul class="flex flex-wrap" v-if="listDatas.imgList && listDatas.imgList.length>0">
                          <li :key="index_child" :style="{width:getItemWidth(listDatas.imgList.length)}"
                              class=" p-4 fs-s-0"
                              v-for="(item_child,index_child) in listDatas.imgList">
                            <div class="flex a-center j-center border"
                                 style="background: #F8F8F9;width: 40%"
                                 v-if="listDatas.imgList.length === 1">
                              <img  style="object-fit: cover" :src="getShowImg(item_child)" alt="" class="w-full h-full"
                                   @click.stop="preview(item_child)"
                              >
                            </div>

                            <ratio-div :RadioValue="82" v-if="listDatas.imgList.length===2">
                              <div
                                class="w-full h-full absolute top-0 left-0 flex a-center j-center border"
                                style="background: #F8F8F9">
                                <img style="object-fit: cover" :src="getShowImg(item_child)" alt="" class="w-full h-full"
                                     @click.stop="preview(item_child)"
                                     v-if="item_child.imgUrl">
                              </div>
                            </ratio-div>
                            <ratio-div :RadioValue="100" v-if="listDatas.imgList.length>2">
                              <div
                                class="w-full h-full absolute top-0 left-0 flex a-center j-center border"
                                style="background: #F8F8F9">
                                <img style="object-fit: cover" :src="getShowImg(item_child)" alt="" class="w-full h-full"
                                     @click.stop="preview(item_child)"
                                     v-if="item_child.imgUrl">
<!--                                <div-->
<!--                                  class="absolute w-full h-full left-0 top-0 flex a-center j-center fs-30 bold text-white"-->
<!--                                  style="background: #00000040"-->
<!--                                  v-if="listDatas.imgList.length>6 && index_child===5">-->
<!--                                  <span>+</span> <span-->
<!--                                  class="m-l-5">{{ listDatas.imgList.length - 6 }}</span>-->
<!--                                </div>-->
                              </div>
                            </ratio-div>
                          </li>
                        </ul>
                      </div>

                      <div class="m-t-10 flex a-center" v-if="getshowGroup">
                        <img src="../../../assets/common/ic_group.png" style="width: 14px;height: 14px;">
                        <div class="m-l-5" style="color: #417BE3">
                          {{getshowGroup}}
                        </div>
                      </div>
                      <div class="m-t-5 flex a-center" v-if="getshowAddress">
                        <img src="../../../assets/common/ic_dizhi_address.png" style="width: 14px;height: 14px;">
                        <div class="m-l-5" style="color: #417BE3">
                          {{getshowAddress}}
                        </div>
                      </div>
                      <div class="m-t-5 flex a-center" v-if="getshowLinkGood">
                        <img src="../../../assets/common/ic_link.png" style="width: 14px;height: 14px;">
                        <div class="m-l-5 fs-12" style="color: #417BE3;cursor: pointer">
                          {{getshowLinkGood}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="m-h-5 p-5 m-b-10  flex j-end a-center" style="background-color: #F8F8F9;height: 42px">
                  <span class="fs-16 color-333 bold">动态评论 {{commentList.length}} 条</span>
                  <div class="flex-1"></div>
<!--                  <Button type="primary" @click="addComment">发布评论</Button>-->
                </div>

                <div class="m-h-10" v-if="commentList && commentList.length">
<!--                  <div class="flex a-center j-between p-v-15 m-t-5 b-b">-->
<!--                    <span class="fs-16 color-333 bold">动态评论 {{commentList.length}} 条</span>-->
                    <!--<span class="fs-16 color-333">清除</span>-->
<!--                  </div>-->
                  <div :key="index" class="flex p-b-30 b-b m-v-20 item_reply_style" v-for="(item,index) in commentList">
                    <div>
                      <img :src="getCommentUserHeader(item)"
                           alt=""
                           style="width: 66px;height: 66px;border-radius: 50%">
                    </div>
                    <div class="m-l-20 m-t-4 w-full">
                      <div class="flex a-center j-start ">
                        <span class="color-333 fs-16 bold">{{item.name || '老刀评论者'}}</span>
                        <div class="flex-1"></div>
                        <div class="color-666 fs-14 m-r-30">{{item.publishTime}}</div>
                        <span @click="onItemDelClick(item)" class="color-333 fs-14" style="color: #E80000">删除</span>
                      </div>
                      <div class="fs-16 color-333 bold m-t-10">
                        {{item.desc || ''}}
                      </div>
                      <div class="m-t-10 fs-14" style="color: #417BE3" v-if="item.replyList.length">
                        已有{{item.replyList.length}}条回复
                      </div>
                      <div class="m-t-8  p-h-20 o-y-auto" style="background: #F5F7FA;max-height: 390px"
                           v-if="item.replyList.length">
                        <div :key="index_child" class="b-b p-v-10 item_reply_style"
                             v-for="(item_child,index_child) in item.replyList">
                          <div class="fs-16" style="color: #417BE3">{{getShowReplyer(item_child)}}：</div>
                          <div class="fs-14 color-333 m-v-5">
                            {{item_child.content}}
                          </div>
                          <div class="fs-14 color-999">{{item_child.replyTime}}</div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--图片预览-->
    <Modal :closable="true" class="modal-setting" class-name="vertical-center-modal" footer-hide title=""
           v-model="previewModal.show"
           width="650">
      <p class="text-center" slot="header">
        <span>{{ previewModal.title }}</span>
      </p>
      <div class="p-h-10 p-b-10 o-y-auto"
           style="min-height: 200px;max-height: 600px">
        <img :onerror="loadImgError"
             :src="previewModal.picUrl?previewModal.picUrl:require('../../../assets/common/ic_wutu@2x.png')"
             style="width: 100%">
      </div>
    </Modal>
    <add-comment-widget
      ref="addCommentWidget"
    />
  </base-page-component>
</template>

<script>
import BasePageComponent from '../../../components/common/BasePageComponent'
import {mapActions, mapMutations} from 'vuex'
import AddCommentWidget from '@/views/material/example/components/AddCommentWidget'
import RatioDiv from '@/components/common/RatioDiv'

export default {
  name: 'CaseDetail',
  components: {RatioDiv, AddCommentWidget, BasePageComponent},
  data () {
    return {
      id: '',
      listDatas: {},
      commentList: [],
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10000,
      },
      previewModal: {
        title: '',
        show: false,
        picUrl: '',
      },
      loadImgError: 'this.src="' + require('../../../assets/common/ic_wutu@2x.png') + '"',
    }
  },
  computed: {
    getShowVideoUrl () {
      let videourl = ''
      if (this.listDatas && this.listDatas.videoList && this.listDatas.videoList.length) {
        return this.listDatas.videoList[0].videoUrl
      }
      return videourl
    },
    getshowUserIcon () {
      if (this.listDatas && this.listDatas.user && this.listDatas.user.icon) {
        return this.listDatas.user.icon
      }
      return require('../../../assets/common/ic_user_default.png')
    },
    getshowGroup (item) {
      let str = ''
      if (item && item.groupName) {
        str = item.groupName
      } else if (item && item.categoryName) {
        str = item.categoryName
      } else {
        str = '案例'
      }
      return str
    },
    getshowAddress () {
      let str = ''
      if (this.listDatas && this.listDatas.location) {
        let location = this.listDatas.location
        let prov = location.prov || ''
        let city = location.city || ''
        let dist = location.dist || ''

        let prefix = prov + city
        if (dist) {
          if (prefix) {
            str = prefix + '·' + dist
          } else {
            str = dist
          }
        }
      }
      return str
    },
    getshowLinkGood () {
      let str = ''
      if (this.listDatas && this.listDatas.goodsList && this.listDatas.goodsList.length) {
        str = this.listDatas.goodsList.map(res => {
          return res.name
        }).join(',')
      }
      return str
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.id = parseInt(this.$route.query.caseId || 0)
      await this.getDetailList()
      this.getConmmentLists()
    },
    getDetailList () {
      let _this = this
      return new Promise(((resolve, reject) => {
        let params = {}
        let id = this.id
        this.getbbsDetail({
          id,
          params
        }).then(res => {
          if (res.code === 0) {
            var arr = res.data
            _this.listDatas = res.data
            resolve(arr)
          }
        })
      }))
    },
    async getConmmentLists () {
      this.commentList = await this.getConmmentList()
    },
    getConmmentList () {
      return new Promise(((resolve, reject) => {
        let params = {
          relationId: this.id,
          relationType: 1,
          pageSize: this.tablePage.pageSize,
          pageNum: this.tablePage.currentPage
        }
        this.getComment(params).then(res => {
          if (res.code === 0) {
            let arr = res.data.list.map(child => {
              let user = child.user
              let icon = ''
              let name = ''
              let desc = ''
              if (user) {
                icon = user.icon || ''
                name = user.name || ''
              }
              let textDao = child.textDto
              if (textDao) {
                desc = textDao.content || ''
              }
              let replyList = child.replyList || []
              return {
                id: child.number,
                publishTime: child.publishTime || '',
                icon: icon,
                name: name,
                desc: desc,
                deleteable: child.deleteable,
                replyList: replyList
              }
            })
            resolve(arr)
          }
        })
      }))

    },
    // 点击返回按钮
    goback () {
      this.$router.go(-1)
      this.closeTag({
        name: 'casedetail'
      })
    },
    // 全部清除
    allClear () {

    },
    //删除素材
    delItem () {
      this.$Modal.confirm({
        title: '删除动态',
        content: '<p>是否删除该动态？</p>',
        onOk: () => {
          let params = {}
          let id = this.id
          this.delBbs({
            id,
            params
          }).then(res => {
            if (res.code === 0) {
              this.goback()
            }
            this.$Message.success(res.msg)

          })

        },
        onCancel: () => {
        }
      })

    },
    onItemDelClick (item) {
      this.$Modal.confirm({
        title: '删除评论',
        content: '<p>是否删除该评论？</p>',
        onOk: () => {
          let params = {}
          let id = item.id
          this.delComments({
            id,
            params
          }).then(res => {
            if (res.code === 0) {
              this.getConmmentLists()
            }
            if (res.msg) {
              this.$Message.success(res.msg)
            }
          })

        },
        onCancel: () => {
        }
      })

    },
    getCommentUserHeader (item) {
      if (item.icon) {
        return item.icon
      }
      return require('../../../assets/common/ic_user_default.png')
    },
    getShowReplyer (item) {
      let userName = '回复人员'
      if (item.user && item.user.name) {
        userName = item.user.name
      }
      return userName
    },
    getShowImg (item) {
      if (item.imgUrl) {
        return item.imgUrl
      }
      return require('../../../assets/common/ic_picture_center.png')
    },
    getItemWidth (len) {
      let dWidth = '33.3%'
      switch (len) {
        case 1:
          dWidth = '100%'
          break
        case 2:
          dWidth = '50%'
          break
        default:
          break
      }
      return dWidth
    },
    /**
     * 图片预览
     * @param row
     */
    preview (row) {
      this.previewModal.title = row.title || '图片预览'
      this.previewModal.picUrl = row.imgUrl
      this.previewModal.show = true
    },
    addComment(){
      this.$refs.addCommentWidget.show()
    },
    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'getbbsDetail',
      'getComment',
      'delBbs',
      'delComments'
    ])
  }
}
</script>

<style lang="scss" scoped>

  .VideoImg {
    display: block;
  }

  .VideoImgBox:hover .VideoImg, {
    display: none;
  }

  .VideoImgHover {
    display: none;
  }

  .VideoImgBox:hover .VideoImgHover {
    display: block;
  }

  .item_reply_style:last-child {
    border-bottom: none;
  }

</style>
